import axios from "axios";
import { useState } from "react";
import { toast } from "./ui/sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function NewsletterForm() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setStatus("");
    try {
      const { data } = await axios.post(`${API}/newsletter`, {
        email,
        source: "dolosworld-footer",
      });
      setStatus(data.message);
      toast.success(data.message);
      setEmail("");
    } catch (error) {
      const detail = error.response?.data?.detail;
      const message =
        typeof detail === "string" ? detail : (Array.isArray(detail) && detail[0]?.msg) || "TRANSMISSION FAILED. RETRY SIGNAL.";
      setStatus(message);
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className="newsletter-form" onSubmit={submit} data-testid="newsletter-form">
      <label htmlFor="newsletter-email">SUBSCRIBE TO THE BLACK-OPS NET</label>
      <div className="terminal-input-row">
        <input
          id="newsletter-email"
          type="email"
          value={email}
          onChange={(event) => setEmail(event.target.value)}
          placeholder="Enter your frequency..."
          required
          disabled={loading}
          data-testid="newsletter-email-input"
        />
        <button type="submit" disabled={loading} data-testid="newsletter-submit-button">
          {loading ? "TRANSMITTING" : "[ TRANSMIT ]"}
        </button>
      </div>
      <p className="terminal-status" aria-live="polite" data-testid="newsletter-status-message">
        {status || "Exclusive drop dates, art books, and TCG expansion updates."}
      </p>
    </form>
  );
}
